/*
 * Button Atom Component
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { navigate } from "gatsby"
import Icon from "../icon/icon"

const Button = props => {
  return (
    <>
      {props.isBackButton ? (
        <button
          className={`button button--back-button`}
          onClick={() => navigate(props.to)}
        >
          <Icon name="chevron" />
          <span className="sr-only">navigate </span>
          <span className="button__text">Back to {props.path}</span>
        </button>
      ) : (
        <button
          id={props.id}
          type={props.type}
          className={`button ${props.className} button${props.modifier}`}
          onClick={props.onClick}
          disabled={props.disabled}
          onMouseEnter={props.onMouseEnter}
          onMouseOut={props.onMouseOut}
          onBlur={props.onBlur}
          haspopup={props.hasPopup}
          aria-label={props.ariaLabel}
          aria-expanded={props.ariaExpanded}
          aria-controls={props.ariaControls}
          role={props.role}
        >
          {props.icon ? (
            <Icon
              name={props.icon}
              title={props.iconTitle}
              modifier={props.iconModifier}
            />
          ) : (
            <></>
          )}
          <span className="sr-only">{props.srOnly}</span>
          <span className="button__text">{props.text}</span>
        </button>
      )}
    </>
  )
}

Button.defaultProps = {
  id: "",
  className: "",
  modifier: "",
  type: "button",
  text: "Button text",
  srOnly: "",
  onClick: () => {},
  disabled: false,
  icon: "",
  iconTitle: "",
  iconModifier: "",
  hasPopup: "false", // Should be a string
  onMouseEnter: () => {},
  onMouseOut: () => {},
  onBlur: () => {},
  ariaLabel: "",
  ariaControls: "",
  ariaExpanded: false,
  role: "",
}

Button.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.oneOf(["button", "submit"]),
  text: PropTypes.string.isRequired,
  srOnly: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconTitle: PropTypes.string,
  iconModifier: PropTypes.oneOf(["", "--small", "--x-small", "--social-icons"]),
  hasPopup: PropTypes.string, // Should be a string
  onMouseEnter: PropTypes.func,
  onMouseOut: PropTypes.func,
  onBlur: PropTypes.func,
  ariaLabel: PropTypes.string,
  ariaControls: PropTypes.string,
  ariaExpanded: PropTypes.bool,
  modifier: PropTypes.oneOf([
    "",
    "--marine",
    "--open-menu",
    "--submenu-button",
    "--close-button",
    "--credits-button",
    "--toggle-filter",
    "--filter-by-button",
  ]),
  role: PropTypes.oneOf([
    "",
    "checkbox",
    "combobox",
    "link",
    "menuitem",
    "menuitemcheckbox",
    "menuitemradio",
    "option",
    "radio",
    "switch",
    "tab",
  ]),
}

export default Button
